module.exports = __webpack_public_path__ + "static/media/googleplay.7cf07086.png";